import { CommonTooltips } from "@mcleod/common";
import { Label, PrintableEvent, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutTariffManagementList } from "./autogen/AutogenLayoutTariffManagementList";
import { TariffManagementUtil } from "./TariffManagementUtil";

export class TariffManagementList extends AutogenLayoutTariffManagementList {

    override async onLoad() {
        this.mainDataSource.search();
        this.setExportName();
    }

    private setExportName() {
        const dateStamp = TariffManagementUtil.dateStamp();
        this.tableTariffManagement.exportName = `Tariff_Management_${dateStamp}`;
    }

    tableTariffManagementOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const labelDeficitRating = tableRow.findComponentById("labelDeficitRating") as Label;
        const labelTariffId = tableRow.findComponentById("labelTariffId") as Label;
        const deficitRating: boolean = tableRow.data.get("apply_deficit_rating_flag");
        labelDeficitRating.text = deficitRating ? "Yes" : "No";
        const tariffID = tableRow.data.get("tariff_id");
        if (!StringUtil.isEmptyString(tariffID)) {
            CommonTooltips.setTooltipContentLayout(labelTariffId, null, "lme/dispatch/TariffQuickInfo", null, { tariff_id: tariffID });
        }
    }

    textboxDimensionalWeightFactorOnPrintable(event: PrintableEvent) {
        const dimensionWeightFactor = event.target;
        dimensionWeightFactor.fillRow = true;
    }

    textboxMinimumWeightPalletOnPrintable(event: PrintableEvent) {
        const miniumWeightPallet = event.target;
        miniumWeightPallet.fillRow = true;
    }

}
